import React, { useState, useEffect } from 'react';
import Constants from 'components/layout_and_quote_builder/Constants.jsx'

// The material sheet(s) are computed server-side from the section's templates and the fixed
// allowances (issue #5194, "Malzeme Tabakasi Bulma"). They are no longer chosen -- or shown -- on the
// page: the material sheet dimension dropdowns are hidden. This component keeps the (invisible) job of
// forwarding the computed layout_dimension_ids (which arrive in `defaultValues` from the
// default-material-values endpoint) and the solution-filtering toggle to the combinations request via
// publicSetter; only the filtering and bobbin toggles are rendered.
// This is the LEGACY page's bobbin row. On /mcc (Frank) the bobbin moves into the unified section-filter
// block ManufacturingLineLists draws (issue #5311, A1).
const ChooseLayoutDimensions = ({ index, defaultValues, publicSetter, onBobbinChange }) => {
  const [layout_dimension_filtering_enabled, set_layout_dimension_filtering_enabled] = useState(false);

  // The bobbin question is ANSWERED BY THE SERVER (BobbinGating), and arrives with the computed sheets in the
  // default-material-values payload: whether to draw the row at all, whether the customer may change it, and
  // how it starts. The rule is not restated here, so the checkbox cannot disagree with the bobbin state the
  // sheets were found for. Absent until the first payload lands -> nothing to draw yet; a payload that lands
  // WITHOUT one is reported by reportMissingBobbinAnswer, where the parent receives it.
  const bobbin = (defaultValues && defaultValues.bobbin) || {};
  const bobbin_shown = bobbin.shown === true;
  const bobbin_forced = bobbin.forced === true;
  const bobbin_default = bobbin.default_enabled === true;
  const [bobbin_enabled, set_bobbin_enabled] = useState(bobbin_default);

  const effective_bobbin_enabled = bobbin_forced ? true : bobbin_enabled;

  const getPublicData = () => {
    return {
      ...defaultValues,
      layout_dimension_filtering_enabled,
      bobbin_enabled: effective_bobbin_enabled,
    }
  }

  // When the part_type becomes known (or changes), reset the checkbox to the server's default for it. Keyed on
  // the part_type rather than on the default itself, so a manual choice is dropped even when the two part_types
  // happen to start the same way.
  const part_type = defaultValues && defaultValues.part_type;
  useEffect(() => {
    set_bobbin_enabled(bobbin_default);
  }, [part_type])

  useEffect(() => {
    if (publicSetter != undefined) {
      publicSetter(() => getPublicData());
    }
    emitEvent(Constants.layout_dimension_changed, { index: index });
  }, [layout_dimension_filtering_enabled, effective_bobbin_enabled])

  return (<>
    <div>
      <table className="table table-bordered">
        <tbody>
          {bobbin_shown &&
            <tr>
              <td colSpan="3" style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <label style={{display: 'flex', alignItems: 'center', cursor: bobbin_forced ? 'default' : 'pointer'}}>
                  <input
                    type="checkbox"
                    checked={effective_bobbin_enabled}
                    disabled={bobbin_forced}
                    onChange={(e) => {
                      set_bobbin_enabled(e.target.checked);
                      // Re-run the material-sheet finder for the new bobbin value so "Chosen material
                      // dimensions" recomputes (bobbin true/false changes the result).
                      if (onBobbinChange != undefined) { onBobbinChange(e.target.checked); }
                    }}
                    style={{marginRight: '8px'}}
                  />
                  <span>{t('quote_builder.bobbin')}</span>
                </label>
              </td>
            </tr>
          }
          {/* Solution filtering is a solve input; Frank mode (the /mcc page) shows only material sheets,
              with no solve, so the toggle is hidden there. */}
          {!window.frank_mode &&
            <tr>
              <td colSpan="3" style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                  <input
                    type="checkbox"
                    checked={layout_dimension_filtering_enabled}
                    onChange={(e) => set_layout_dimension_filtering_enabled(e.target.checked)}
                    style={{marginRight: '8px'}}
                  />
                  <span>{t('quote_builder.solution_filtering')}</span>
                </label>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div style={{'clear': 'both'}}></div>
  </>)
}

export default ChooseLayoutDimensions;
